import { useAppSelector } from '@/app/store/hooks';
import { useAuth } from '@/features/auth';

export function useTemplateOwnerContext() {
  const { isInternal } = useAuth();
  const homeDealerId = useAppSelector((state) => state.auth.dealerId);
  return { isInternal, homeDealerId };
}
